import { FaPlus, FaCheckCircle, FaSearch } from "react-icons/fa"
import { MdTimer } from "react-icons/md"
import ActionButton from "../ui/ActionButton"

export default function QuickActions() {
  const actions = [
    {
      title: "New Project",
      icon: FaPlus,
      path: "/admin/project/create-new-project",
    },
    {
      title: "Approval List",
      icon: FaCheckCircle,
      path: "/admin/approval-form",
    },
    {
      title: "Log Time",
      icon: MdTimer,
      path: "/admin/time-tracking",
    },
    {
      title: "Material List",
      icon: FaSearch,
      path: "/admin/material-list",
    },
  ]

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {actions.map((action, index) => (
          <ActionButton key={index} title={action.title} icon={action.icon} path={action.path} />
        ))}
      </div>
    </div>
  )
}

